import createLogger from 'vuex/dist/logger';
import app from './modules/app/index';
import user from './modules/user/index';
import customer from './modules/customer/index';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  modules: {
    app,
    user,
    customerBase: customer,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});
export default store;
